// extracted by mini-css-extract-plugin
export default {"linkStyle":"MedicalVisits_linkStyle__8uo0o"};